import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // El documento arranca con el fondo de SU ruta (index.html o el HTML
    // prerenderizado), pero la navegación SPA no recarga el documento: hay que
    // conmutar el navy del hero (html.route-home / route-dark) al cambiar de página.
    // [ULTURE] Ya no hay <meta name="theme-color"> (actualización 01 del diseño, cambio 12:
    // la página pasa por detrás de la barra del navegador en móvil), así que no se toca.
    const home = pathname === "/";
    // /tactic y /pest (páginas nuevas de cada app) también arrancan con un hero navy a sangre.
    const dark = /^\/(tactic|pest)\/?$/.test(pathname);
    document.documentElement.classList.toggle("route-home", home);
    document.documentElement.classList.toggle("route-dark", dark);
  }, [pathname]);

  return null;
}
